import { memo, useId } from 'react';
import { useTranslation } from '@aimsos/i18n';
import MarketplaceCard from './MarketplaceCard.jsx';

/**
 * A curated marketplace section (CT-4164): a labeled row of `MarketplaceCard`s,
 * reused for "Popular in your workspace" and "New from verified partners".
 *
 * Cards scroll horizontally inside an `overflow-x-auto` container so the page
 * body never scrolls horizontally. Curated content is data-driven (mock now).
 *
 * `aria-labelledby` names the `<section>` landmark from its own heading so
 * screen readers can navigate directly to "Popular" vs "New from partners".
 */
function CuratedGrid({ titleKey, items = [], onOpen }) {
  const { t } = useTranslation('admin-studio');
  const headingId = useId();
  if (!items.length) return null;

  return (
    <section className="flex flex-col gap-3" aria-labelledby={headingId}>
      <h3 id={headingId} className="text-sm font-semibold text-content">
        {t(titleKey)}
      </h3>
      <div className="-mx-1 flex gap-3 overflow-x-auto px-1 pb-1">
        {items.map((view) => (
          <div key={view.id} className="w-72 shrink-0">
            <MarketplaceCard view={view} onOpen={onOpen} />
          </div>
        ))}
      </div>
    </section>
  );
}

export default memo(CuratedGrid);
